import React from 'react';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';

import FloatNumberFormatInput from '../../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../../components/int_number_input_formatter';
import DatePicker from '../../../components/utils/DatePicker';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { Tooltip, Fade } from '@material-ui/core';

import { getDescr } from '../../../reducers/reducer_promocion';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 50,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
    width_descr: {
        width: 400,
    },
    width_int_md: {
        width: 150,
    },
    width_float_sm: {
        width: 100,
    },
    width_date: {
        width: 200,
    },
});

class EditPromocion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.promocion.id ? this.props.promocion.id : uuidv4(),
            centroId: this.props.centroId ? this.props.centroId : undefined,
            usuarioId: this.props.usuarioId ? this.props.usuarioId : undefined,
            descr: this.props.promocion.descr ? this.props.promocion.descr : '',
            activa: this.props.promocion.activa
                ? this.props.promocion.activa
                : true,
            puntosPorEuro: this.props.promocion.puntosPorEuro
                ? this.props.promocion.puntosPorEuro
                : undefined,
            puntosFijos: this.props.promocion.puntosFijos
                ? this.props.promocion.puntosFijos
                : undefined,
            fAlta: this.props.promocion.fAlta
                ? this.props.promocion.fAlta.slice(0, 10)
                : new Date().toISOString().slice(0, 10),
            obsv: this.props.promocion.obsv ? this.props.promocion.obsv : '',
            iTipoPromocion: this.props.promocion.iTipoPromocion
                ? this.props.promocion.iTipoPromocion
                : 1,
            tipoPromocionDescr: getDescr(
                this.props.promocion.iTipoPromocion
                    ? this.props.promocion.iTipoPromocion
                    : 1,
            ),
        };
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };

    handleChangeSelect = event => {
        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoPromocion: value,
            tipoPromocionDescr: getDescr(value),
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl
                        className={`${classes.formControl} ${classes.width_descr}`}
                    >
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={event =>
                                this.handleValueChange(event, 'descr')
                            }
                        />
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl
                        className={`${classes.formControl} ${classes.width_float_sm}`}
                    >
                        <Tooltip
                            title="Puntos por euro de la promoción"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <TextField
                                id={'puntosPorEuro'}
                                label={'Puntos/€'}
                                placeholder={'Puntos/€'}
                                className={classes.textField}
                                margin="normal"
                                InputProps={{
                                    classes: { input: classes.rtl },
                                    inputComponent: FloatNumberFormatInput,
                                }}
                                value={this.state.puntosPorEuro}
                                onChange={event =>
                                    this.handleValueChange(
                                        event,
                                        'puntosPorEuro',
                                    )
                                }
                            />
                        </Tooltip>
                    </FormControl>
                    <FormControl
                        className={`${classes.formControl} ${classes.width_int_md}`}
                    >
                        <Tooltip
                            title="Puntos fijos de la promoción"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <TextField
                                id={'puntosFijos'}
                                label={'Puntos fijos'}
                                placeholder={'Puntos fijos'}
                                className={classes.textField}
                                margin="normal"
                                InputProps={{
                                    classes: { input: classes.rtl },
                                    inputComponent: IntNumberFormatInput,
                                }}
                                value={this.state.puntosFijos}
                                onChange={event =>
                                    this.handleValueChange(event, 'puntosFijos')
                                }
                            />
                        </Tooltip>
                    </FormControl>
                    <FormControl
                        className={`${classes.formControl} ${classes.width_date}`}
                    >
                        {/* <TextField
                            id={'fAlta'}
                            label={'Fecha Alta'}
                            placeholder={'Fecha Alta'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.fAlta}
                            onChange={(event) => this.handleValueChange(event, 'fAlta')}
                        /> */}
                        <DatePicker
                            label={'Fecha Alta'}
                            value={this.state.fAlta}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fAlta')
                                }
                            }}
                        />
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="tipo-promocion-placeholder">
                            Tipo Promocion
                        </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoPromocion}
                            onChange={event => this.handleChangeSelect(event)}
                        >
                            <option value={1}>{getDescr(1)}</option>
                            <option value={2}>{getDescr(2)}</option>
                            <option value={3}>{getDescr(3)}</option>
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.activa ? true : false}
                                    onChange={event =>
                                        this.handleBooleanChange(
                                            event,
                                            'activa',
                                        )
                                    }
                                    value="activa"
                                />
                            }
                            label="Activa"
                        />
                    </FormControl>
                </div>
                <div>
                    <FormControl className={classes.formComent}>
                        <TextField
                            multiline
                            rows="3"
                            id={'obsv'}
                            label={'Observaciones'}
                            placeholder={'Observaciones'}
                            margin="normal"
                            value={this.state.obsv}
                            onChange={event =>
                                this.handleValueChange(event, 'obsv')
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const promocion = {
                                id: this.state.id,
                                centroId: this.state.centroId,
                                usuarioId: this.state.usuarioId,
                                descr: this.state.descr,
                                activa: this.state.activa,
                                puntosPorEuro: this.state.puntosPorEuro,
                                puntosFijos: this.state.puntosFijos,
                                fAlta: this.state.fAlta,
                                obsv: this.state.obsv,
                                iTipoPromocion: this.state.iTipoPromocion,
                                tipoPromocionDescr: this.state
                                    .tipoPromocionDescr,
                            };
                            if (this.props.checkPromocion(promocion)) {
                                this.props.okHandler(promocion);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditPromocion.propTypes = {
    promocion: PropTypes.object.isRequired,
    checkPromocion: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditPromocion);
